
import {
  defineComponent,
  ref,
  reactive,
  onMounted,
  computed,
} from 'vue'
import { useStore } from 'vuex'
import Swal from 'sweetalert2'
import axios from 'axios'
import { Modal,notification } from 'ant-design-vue'
import { useRouter } from 'vue-router'
import {  h } from 'vue';
import Loader from '../components/Loader.vue'

export default defineComponent({
  components: {
    Loader 
  },

  setup () {
    const showUploadForm = ref(false)
    const router = useRouter()
    const form_action = ref('save')
    const store = useStore()

    const loader_title = ref('Updating')
    const loader_content = ref('Updating and Sending Notification...')
    const visible_update_modal = ref(false);

    const current_page = ref(1)
    const current_page_archive = ref(1)

    const fields = ref([
        {
            title: 'Invoice No.',
            dataIndex: 'invoice_number',
            fixed: true
        },
        {
            title: 'Invoice Amount',
            dataIndex: 'invoice_amount',
            fixed: true
        },
        {
            title: 'Invoice Status',
            dataIndex: 'invoice_status',
        },
        {
            title: 'Invoice Description',
            dataIndex: 'invoice_description',
        },
        {
            title: 'Assigned End User',
            dataIndex: 'end_user_name',
        },
        // {
        //     title: 'Business Unit',
        //     dataIndex: 'site_name',
        // },
        {
            title: 'Action',
            dataIndex: 'action',
            slots: {customRender: 'action'},
            align: 'center'
        }
    ])

    const index = (payload = {page: 1}) => {
      payload.page = current_page.value;
      store.dispatch('VendorInvoice/index', payload)
      .then((res) => {
        if(current_page.value > res.data.last_page) {
          current_page.value = res.data.last_page
          index()
        }
      })
    }

    const indexArchive = (payload = {page: 1}) => {
      payload.page = current_page_archive.value;
      store.dispatch('VendorInvoice/archive_lists', payload)
      .then((res) => {
        if(current_page_archive.value > res.data.last_page) {
          current_page_archive.value = res.data.last_page
          indexArchive()
        }
      })
    }

    const filterRecord = (payload: any) => {
      current_page.value = payload.page;
      index(payload)
    }

    const filterRecordArchives = (payload: any) => {
      current_page_archive.value = payload.page;
      indexArchive(payload)
    }

    const createRecord = () => {
      router.push('/invoice/create');
    }

    const editRecord = (record: any) => {
      router.push({path: '/invoice/edit/'+record.id});
    }

    const deleteRecord = (record: any) => {
      visible_update_modal.value = true
      store.dispatch('VendorInvoice/destroy', record.id).then(() => {
        visible_update_modal.value = false
        index()
        indexArchive()
      }).catch((err) => {
        visible_update_modal.value = false
      });
    }


    onMounted(() => {
      index()
      indexArchive()
    })

    const items = computed(() => store.getters['VendorInvoice/items'])
    const archive_items = computed(() => store.getters['VendorInvoice/archive_items'])
    const loading = computed(() => store.getters['VendorInvoice/status'])
    const archive_loading = computed(() => store.getters['VendorInvoice/archive_status'])

    return {
      items,
      archive_items,
      loading,
      archive_loading,
      fields,
      form_action,
      showUploadForm,
      filterRecord,
      filterRecordArchives,
      createRecord,
      editRecord,
      deleteRecord,
      visible_update_modal,
      loader_title,
      loader_content,
    }
  },
})
